export default {
	tabs: ["Депозит", "История"],
	History: {
		tabs: ["Проверка", "Успех", "Отклонить"]
	},
	AccountAmount: "Сумма на счете",
	ContactCustomerService: "Связаться с службой поддержки",
	NoCustomerService: "Служба поддержки занята",
	tips: "Пожалуйста, предоставьте предыдущую оценку перед тем, как продолжить следующую оценку!"
};
